import React, { FunctionComponent } from 'react';
import { Icon, MenuItem, MenuDivider } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import {IWorkspace} from '../../../models';
import VoidElement from '../../VoidElement';
import {useCurrentWorkspace} from '../../../hooks';
import {sortWorkspaces} from '../../workspaces/utils';

type Workspaces = IWorkspace[] | undefined | null;

interface IWorkspacesPerOrganization {
  [key: string]: {
    organization: any,
    workspaces: IWorkspace[]
  }
}

interface IMenuItemProps {
  workspaces: Workspaces,
  onChangeWorkspace: Function,
  endDivider?: boolean,
  showAllWorkspaces?: boolean;
}

const _sortByName = (a: any, b: any) => {
  const nameA = (a.organization.name || '').toLowerCase();
  const nameB = (b.organization.name || '').toLowerCase();

  if (nameA > nameB) {
    return 1;
  } else if (nameA < nameB) {
    return -1;
  }
  return 0;
}

export const WorkspaceMenuItemElements: FunctionComponent<IMenuItemProps> = ({
  workspaces,
  onChangeWorkspace,
  showAllWorkspaces
}: IMenuItemProps) => {
  const currentWorkspace = useCurrentWorkspace();

  if (
    !workspaces ||
    (workspaces && (showAllWorkspaces ? false : workspaces.length <= 1))
  ) {
    return null;
  }

  const workspacesPerOrganization = workspaces
    .reduce((acc, workspace) => {
      const organization = workspace.organization;
      const key = organization.uid;

      if (!acc.hasOwnProperty(key)) {
        acc[key] = {
          organization: organization,
          workspaces: []
        }
      }
      acc[key].workspaces.push(workspace);

      return acc;
    }, {} as IWorkspacesPerOrganization)

  const totalOrg = Object.keys(workspacesPerOrganization).length;
  const lastOrgIndex = totalOrg - 1;

  return (
    <>
      {
        Object
          .values(workspacesPerOrganization)
          .sort(_sortByName)
          .map((obj: any, index) => {
            const organization = obj.organization;
            const workspaces = obj.workspaces;

            if (workspaces.length === 1) {
              /*
               * If there is only one workspace per organization, show organization name and make it clickable
               */
              const onlyWorkspace = workspaces[0];
              return (
                <VoidElement key={"org_" + organization.uid}>
                  <MenuItem
                    key={organization.uid}
                    icon={IconNames.OFFICE}
                    text={organization.name}
                    className="header-avatar__organization-name"
                    disabled={onlyWorkspace.uid === currentWorkspace?.uid}
                    onClick={() => {
                      onChangeWorkspace(onlyWorkspace.uid);
                    }}
                    labelElement={onlyWorkspace.is_active ? <Icon icon={IconNames.TICK} /> : undefined}
                  />
                  {index !== lastOrgIndex ? <MenuDivider key={`divider_${index}`}/> : null}
                </VoidElement>
              );
            }

            return (
              <VoidElement key={"org_" + organization.uid}>
                <MenuItem
                  key={organization.uid}
                  icon={IconNames.OFFICE}
                  text={organization.name}
                  className="header-avatar__organization-name"
                  disabled={true} />
                {
                  sortWorkspaces(workspaces).map((workspace) => {
                    return (
                      <MenuItem
                        key={workspace.uid}
                        icon={IconNames.APPLICATION}
                        text={workspace.name}
                        disabled={workspace.uid === currentWorkspace?.uid}
                        onClick={() => {
                          onChangeWorkspace(workspace.uid);
                        }}
                        labelElement={workspace.is_active ? <Icon icon={IconNames.TICK} /> : undefined}
                      />
                    )
                  })
                }
                { index !== lastOrgIndex ? <MenuDivider key={`divider_${index}`} /> : null }
              </VoidElement>
            )
          })
      }
    </>
  )
}
